import { observer } from 'mobx-react-lite';
import { Button, Grid, Header, Input, Segment } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import { useState } from 'react';
import {
  DeliveryRequest,
  DeliveryRequestInitialState,
} from '../../../../app/models/deliveryRequest';
import MyTextInput from '../../../../app/common/form/MyTextInput';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect } from 'react';
import { Activity } from '../../../../app/models/activity';
import sendRespectiveEmail from '../../../../app/models/EmailNew';

function DashboardDeliveryForm() {
  const {
    dashboardStore,
    activityStore,
    DeliveryStore,
    commonStore: { updateHistoryAlonePOST, hfcCustomerChanges },
    userStore: { user },
  } = useStore();
  const [deliveryState, setDeliveryState] = useState<DeliveryRequest>(
    DeliveryRequestInitialState,
  );
  const [itemLevel, setItemLevel] = useState<Activity | undefined>();
  const [disableList, setDisableList] = useState<{
    shipVia: boolean;
    airWay: boolean;
    account: boolean;
    shipTo: boolean;
  }>({
    shipVia: false,
    airWay: false,
    account: false,
    shipTo: false,
  });

  useEffect(() => {
    setItemLevel(activityStore.selectedActivity);
    if (activityStore.selectedActivity?.itemDeliveryRequest) {
      setDeliveryState({
        ...activityStore.selectedActivity?.itemDeliveryRequest?.filter(
          (i) => i.isActive === true,
        )?.[0],
        pickupOn: new Date().toISOString().split('T')[0],
      });
    }
    // eslint-disable-next-line
  }, [activityStore.selectedActivity]);

  useEffect(() => {
    if (
      DeliveryStore.hfcMetadata.length > 0 &&
      activityStore?.selectedActivity?.itemDeliveryRequest
    ) {
      const temp = {
        ...activityStore.selectedActivity?.itemDeliveryRequest?.filter(
          (i) => i.isActive === true,
        )?.[0],
        shipVia:
          DeliveryStore.hfcMetadata.filter(
            (hfc) => hfc.name === 'Ship Via',
          )?.[0]?.value || '',
        airWay:
          DeliveryStore.hfcMetadata.filter(
            (hfc) => hfc.name === 'Tracking#',
          )?.[0]?.value || '',
        account:
          DeliveryStore.hfcMetadata.filter(
            (hfc) => hfc.name === 'Fedex Account',
          )?.[0]?.value || '',
        shipTo:
          DeliveryStore.hfcMetadata.filter((hfc) => hfc.name === 'Theater')?.[0]
            ?.value || '',
        pickupOn: new Date().toISOString().split('T')[0],
      };
      const tempDisable = {
        shipVia: temp.shipVia !== '' ? true : false,
        airWay: temp.airWay !== '' ? true : false,
        account: temp.account !== '' ? true : false,
        shipTo: temp.shipTo !== '' ? true : false,
      };
      setDeliveryState(temp);
      setDisableList(tempDisable);
    }
  }, [
    DeliveryStore.hfcMetadata,
    activityStore.selectedActivity?.itemDeliveryRequest,
    user,
  ]);

  const changeDateTime = (data: string) => {
    if (data !== '') return new Date(data).toLocaleString().split(',')?.[0];
    else return '';
  };

  const handleFormSubmit = async (values: DeliveryRequest) => {
    if (itemLevel !== undefined) {
      const payload = {
        attention: values.attention,
        phone: values.phone,
        shipVia: values.shipVia,
        shipPriority: values.shipPriority,
        airWay: values.airWay,
        account: values.account,
        pickupBy: values.pickupBy,
        pickupByID: values.pickupByID,
        pickupOn: values.pickupOn,
        shipTo: values.shipTo,
      };
      const response = await DeliveryStore.Delivery(
        deliveryState.id,
        payload,
        activityStore.selectedActivity?.id,
      );
      const itemDeliveryReq =
        activityStore.selectedActivity?.itemDeliveryRequest?.filter(
          (i) => i.isActive === true,
        )?.[0];
      const historyPayload = {
        theater: itemDeliveryReq?.movementTo,
        deliveryDate: itemDeliveryReq?.dateOfDelivery || '',
        returnDate: itemDeliveryReq?.dateOfReturn || '',
      };
      setTimeout(() => {
        updateHistoryAlonePOST(
          response,
          activityStore.selectedActivity?.id,
          undefined,
          true,
          true,
        );
        if (hfcCustomerChanges) {
          updateHistoryAlonePOST(
            `${activityStore.selectedActivity?.title} is moving to ${
              historyPayload.theater
            } on ${changeDateTime(
              historyPayload.deliveryDate,
            )} and will be returned back on ${changeDateTime(
              historyPayload.returnDate,
            )}.`,
            activityStore.selectedActivity?.id,
            undefined,
            true,
            true,
          );
          sendRespectiveEmail(
            '',
            '',
            'Asset Movement Notification',
            '',
            '',
            '',
            `This is to notify that ${activityStore.selectedActivity
              ?.title} is moving to ${
              historyPayload.theater
            } on ${changeDateTime(
              historyPayload.deliveryDate,
            )} and will be returned back on ${changeDateTime(
              historyPayload.returnDate,
            )}.`,
          );
        }
      }, 200);

      setDeliveryState(DeliveryRequestInitialState);
      DeliveryStore.listDelivery();
    }
  };
  const handleCancel = () => {
    setDeliveryState(DeliveryRequestInitialState);
  };
  return (
    <>
      <Segment
        clearing
        style={{
          Responsive: true,
          marginTop: '10px',
          height: '61.7vh',
          // padding: "10px",
        }}
        responsive={true}
      >
        <Header
          icon="edit"
          size="huge"
          dividing
          as="h1"
          content="Delivery"
          sub
          color="grey"
        />
        {dashboardStore.dashboard.AssetTableDeliveryClicked.length !== 0 ? (
          <>
            <Formik
              initialValues={deliveryState}
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                handleFormSubmit(values);
                resetForm();
              }}
              validationSchema={Yup.object({
                attention: Yup.string().required('Please Specify Attention'),
                phone: Yup.string().required('Please Specify Phone Number'),
                shipVia: Yup.string().required('Please Specify Ship Via'),
                shipPriority: Yup.string().required(
                  'Please Specify Ship Priority',
                ),
                airWay: Yup.string().required('Please Specify Airway'),
                account: hfcCustomerChanges
                  ? Yup.string().required('Please Specify Carrier Account')
                  : Yup.string().required('Please Specify Account'),
                pickupBy: Yup.string().required('Please Specify Pick Up By'),
                pickupByID: Yup.string().required('Please Specify Pick Up ID'),
                // pickupOn: Yup.string().required('Please Specify Pick Up On'),
                shipTo: Yup.string().required('Please Specify Ship To'),
              })}
            >
              {({
                handleSubmit,
                isSubmitting,
                isValid,
                dirty,
                resetForm,
                values,
              }) => (
                <Form
                  className="ui form error"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  <Grid container columns={2}>
                    <Grid.Column>
                      {' '}
                      <MyTextInput
                        name="attention"
                        placeholder="Attention"
                        label="Attention"
                        value={values.attention}
                      />{' '}
                    </Grid.Column>
                    <Grid.Column>
                      {' '}
                      <MyTextInput
                        name="phone"
                        placeholder="Phone"
                        label="Phone"
                        value={values.phone}
                      />{' '}
                    </Grid.Column>
                  </Grid>
                  <Grid container columns={2}>
                    <Grid.Column>
                      {' '}
                      <MyTextInput
                        name="shipVia"
                        placeholder="Ship Via"
                        label="Ship Via"
                        value={values.shipVia}
                        disabled={disableList.shipVia}
                      />{' '}
                    </Grid.Column>
                    <Grid.Column>
                      {' '}
                      <MyTextInput
                        name="shipPriority"
                        placeholder="Ship Priority"
                        label="Ship Priority"
                        value={values.shipPriority}
                      />{' '}
                    </Grid.Column>
                  </Grid>

                  <Grid container columns={2}>
                    <Grid.Column>
                      {' '}
                      <MyTextInput
                        name="airWay"
                        placeholder="Air Way"
                        label="Air Way"
                        value={values.airWay}
                        disabled={disableList.airWay}
                      />{' '}
                    </Grid.Column>
                    <Grid.Column>
                      {' '}
                      <MyTextInput
                        name="account"
                        placeholder={
                          hfcCustomerChanges ? 'Carrier Account' : 'Account'
                        }
                        label={
                          hfcCustomerChanges ? 'Carrier Account' : 'Account'
                        }
                        value={values.account}
                        disabled={disableList.account}
                      />{' '}
                    </Grid.Column>
                  </Grid>
                  <Grid container columns={2}>
                    <Grid.Column>
                      {' '}
                      <MyTextInput
                        name="pickupBy"
                        placeholder="Pickup By"
                        label="Pickup By"
                        value={values.pickupBy}
                      />{' '}
                    </Grid.Column>
                    <Grid.Column>
                      {' '}
                      <MyTextInput
                        name="pickupByID"
                        placeholder="Pickup By ID"
                        label="Pickup By ID"
                        value={values.pickupByID}
                      />{' '}
                    </Grid.Column>
                  </Grid>
                  <Grid container columns={2}>
                    <Grid.Column>
                      {' '}
                      <label
                        style={{
                          color: 'rgba(0,0,0,.87)',
                          fontSize: '.92857143em',
                          fontWeight: '700',
                          margin: '0 0 .28571429rem 0',
                        }}
                      >
                        Pickup On
                      </label>
                      <Input
                        type="date"
                        name="pickupOn"
                        placeholder="Pickup On"
                        min={new Date().toISOString().split('T')[0]}
                        defaultValue={new Date().toISOString().split('T')[0]}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      {' '}
                      <MyTextInput
                        name="shipTo"
                        placeholder="Ship To"
                        label="Ship To"
                        value={values.shipTo}
                        disabled={disableList.shipTo}
                      />{' '}
                    </Grid.Column>
                  </Grid>
                  <Button.Group floated="right" style={{ marginTop: '40px' }}>
                    <Button
                      onClick={() => {
                        handleCancel();
                        resetForm();
                      }}
                    >
                      {' '}
                      Cancel{' '}
                    </Button>{' '}
                    <Button.Or />
                    <Button
                      disabled={!isValid || !dirty || isSubmitting}
                      type="submit"
                      content="Submit"
                      positive
                    >
                      Submit{' '}
                    </Button>
                  </Button.Group>
                </Form>
              )}
            </Formik>
          </>
        ) : (
          <p style={{ marginTop: '10px' }}>Please select item received</p>
        )}
      </Segment>
    </>
  );
}

export default observer(DashboardDeliveryForm);
